import React, { FunctionComponent } from 'react';

import classnames from 'classnames';
import { find, get, isBoolean, isEqual, isNumber } from 'lodash';
import { useTranslation } from 'react-i18next';

import { SourceId } from 'admin/sources/Sources';
import { RatingAsRecommends as Recommends } from 'core/rating-as-recommends/RatingAsRecommends';
import { Rating } from 'core/rating/Rating';
import { Size } from 'core/rating/types/index';
import { ContextProps } from 'reviews2/feed/review-yeti/Review.types';

import 'reviews2/feed/review-yeti/template/field/TemplateFieldRating.scss';

export const TemplateFieldRating: FunctionComponent<ContextProps> = ({ context }) => {
    const { t } = useTranslation('reviews2');
    const { review } = context;
    const overallMax = review!.source?.overallRS.overallMax;
    const { properties, rating_value, review_source_id } = review;
    const recommended = find(properties, { key: 'Recommended' });
    const isRecommended = get(recommended, 'value[0]') === 'True';

    /**
     * Booking (and potentially other sources) doesn't support star ratings, only numeric ratings
     *
     * TODO: add a field to source def
     */
    const isDisplayIcons = review_source_id !== SourceId.Booking;

    return (
        <div className="r4e-review-template-field-rating">
            {!isEqual(review_source_id, SourceId.Facebook) && isNumber(rating_value) && (
                <Rating
                    isReadOnly
                    colorFull="ff7f2a"
                    size={Size.XSmall}
                    valueMax={overallMax}
                    isDisplayScale={false}
                    isDisplayIcons={isDisplayIcons}
                    selectedValue={rating_value}
                    noRatingText={t('NO_RATING_TEXT')}
                    className={classnames('r4e-review-rating', {
                        'no-display-icons': !isDisplayIcons,
                    })}
                />
            )}
            {isEqual(review_source_id, SourceId.Facebook) && isBoolean(isRecommended) && (
                <Recommends isRecommended={isRecommended} />
            )}
        </div>
    );
};
